import { render, staticRenderFns } from "./Packs.vue?vue&type=template&id=7c090bc6&scoped=true&"
import script from "./Packs.vue?vue&type=script&lang=js&"
export * from "./Packs.vue?vue&type=script&lang=js&"
import style0 from "./Packs.vue?vue&type=style&index=0&id=7c090bc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c090bc6",
  null
  
)

export default component.exports